import React from "react";

function CurvedArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="106"
      height="101"
      fill="none"
      viewBox="0 0 106 101"
    >
      <path
        fill="#466645"
        d="M104.558 14.701c-12.628-2.833-25.644 1.212-35.954 8.658-5.647 4.077-10.502 9.077-14.969 14.357-2.612 3.194-8.754 8.998-6.102 13.62 2.262 3.907 9.172 3.648 12.718 1.835 4.025-2.098 6.403-7.426 4.046-11.638-2.356-4.212-7.725-5.44-12.155-4.42-6.094 1.476-11.609 6.08-16.283 9.953C23.45 57.21 13.471 69.77 3.575 82.27c-.805.955-.28 2.63 1 2.764 4.555.446 8.824-.022 13.088-1.358a145.661 145.661 0 00-1.107-2.998c-2.88 1.27-7.001 3.063-10.254 2.61-2.689-.36-1.993-1.984-1.581-4.086a231.99 231.99 0 011.11-5.532c.352-2.185-3.101-2.742-3.453-.558-.571 3.09-1.61 6.392-1.606 9.501-.039 1.585.343 2.803 1.802 3.617 1.941.964 4.93.362 7.017-.025 2.825-.484 5.496-1.354 8.072-2.529 1.873-.855.873-3.618-1.107-2.998-3.807 1.193-7.537 1.459-11.436.974.38.93.738 1.854 1.07 2.776 7.741-9.885 15.563-19.829 24.576-28.64 4.728-4.66 9.927-9.099 15.505-12.753 2.994-1.975 6.563-3.93 10.32-3.468 3.816.543 7.141 3.682 5.613 7.774-1.4 3.75-5.794 4.993-9.483 4.109-6.203-1.435-.367-7.579 1.556-10.088 3.998-5.066 8.397-9.923 13.48-14.092 10.235-8.325 23.221-13.531 36.518-10.807 1.057.17 1.33-1.52.284-1.762z"
      ></path>
    </svg>
  );
}

export default CurvedArrow;
